import React, { ReactNode, useState, useEffect } from 'react';
import clsx from 'clsx';
import { Icon } from '@scale/scaleui';
import { motion } from 'framer-motion';
import { OutlineStep } from './types';
import { OutlineSectionStep } from 'react-scale/remotasks.com/components/Expert/OutlinePanel/OutlineSectionStep';

type OutlineSectionProps = {
  title: ReactNode;
  titleEndAdornment?: ReactNode;
  active?: boolean;
  muted?: boolean;
  steps: OutlineStep[];
  loading?: boolean;
  onHeaderClick?: () => void;
  onStepClick?: () => void;
  setCurrentSectionIndex?: (index: number) => void;
};

export const OutlineSection = ({
  title,
  titleEndAdornment,
  steps,
  active,
  muted,
  loading,
  onHeaderClick,
  setCurrentSectionIndex,
}: OutlineSectionProps) => {
  const [expanded, setExpanded] = useState(active);
  const handleExpand = () => {
    setExpanded(prev => !prev);
  };

  useEffect(() => {
    setExpanded(active);
  }, [active]);
  const handleStepClick = (index: number) => {
    onHeaderClick && onHeaderClick();
    setCurrentSectionIndex && setCurrentSectionIndex(index);
  };
  return (
    <div
      className={clsx([
        'border-2 rounded w-[436px]',
        active ? 'border-misc-periwinkle100' : 'border-neutral-200',
        muted ? 'opacity-70' : '',
      ])}
    >
      <div
        className={clsx([
          'p-2 grid grid-flow-col items-center gap-1 grid-cols-[auto_1fr_auto]',
          !expanded && 'rounded',
          expanded && 'border-b-2 border-b-neutral-200 rounded-t',
          onHeaderClick !== undefined && 'cursor-pointer',
        ])}
        onClick={onHeaderClick}
      >
        {steps.length > 0 ? (
          <Icon
            className="cursor-pointer"
            icon={expanded ? 'chevron-up' : 'chevron-down'}
            size="sm"
            onClick={handleExpand}
          />
        ) : (
          <span />
        )}
        <span className="font-sm text-xs text-neutral-700">
          {title} {loading && <Icon icon="spinner" size="sm" />}
        </span>
        {titleEndAdornment}
      </div>
      {expanded && (
        <motion.div
          className="bg-neutral-0 w-[100%] rounded-b"
          initial={{ y: -20 }}
          animate={{ y: 0 }}
          transition={{
            ease: 'easeOut',
            duration: 0.15,
          }}
        >
          {steps.map((step, index) => (
            <OutlineSectionStep key={index} step={step} onClick={() => handleStepClick(index)} />
          ))}
        </motion.div>
      )}
    </div>
  );
};
